import { FormikActions } from 'formik';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import withStyles from '@material-ui/core/styles/withStyles';
import Switch from '@material-ui/core/Switch';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { expandConfigView, expandTemplatesView, expandWebhookView } from '../actions/app';
import { toggleToken, updateKey } from '../actions/auth';
import { generateWebhook, installSchema, saveTemplates } from '../actions/config';
import SsoForm from '../components/sso-form';
import TemplatesForm from '../components/template-form';
import WebhookForm from '../components/webhook-form';
import { styles } from '../style';
import { IApp } from '../types/app';

class RoostifyContent extends React.Component<IApp | any, any> {
  public render() {
    const { classes } = this.props;
    return (
      <div style={this.props.style}>
        <Tooltip title='When enabled, this indicates the schema has been installed for this integration'>
          <FormControlLabel
            label='Schema Installed'
            control={
              <Switch checked={this.props.config.enabled} value='installed' onClick={this.toggleInstallSchema} />
            }
          />
        </Tooltip>
        <ExpansionPanel expanded={this.props.app.configuredExpanded} onChange={this.toggleExpandConfig} disabled={!this.props.config.enabled}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>Configure API Key</Typography>
            <Typography className={classes.secondaryHeading}>Configure and authorize Flybits to make calls to provider</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <SsoForm onSubmit={this.saveKey} handleShowToken={this.toggleShowToken}/>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel expanded={this.props.app.templatesExpanded} onChange={this.toggleExpandTemplates} disabled={!this.props.config.enabled}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>Customize Payload Template</Typography>
            <Typography className={classes.secondaryHeading}>Payload to provider can be customized to suit with your environment.</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <TemplatesForm style={{width: '100%'}} onSubmit={this.saveTemplates}/>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel expanded={this.props.app.webhookExpanded} onChange={this.toggleExpandWebhook} disabled={!this.props.config.enabled}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>Webhook</Typography>
            <Typography className={classes.secondaryHeading}>Information about webhook trigger to this integration.</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <WebhookForm style={{width: '100%'}} generateWebhook={this.generateWebhook}/>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div >
    );
  }
  private toggleInstallSchema = () => {
    const accessToken = this.props.authentication.session.id
    const tenantId = this.props.tenant.id
    this.props.dispatch(installSchema(
      accessToken,
      tenantId,
      !this.props.config.enabled,
    ))
  }
  private toggleExpandConfig = () => this.props.dispatch(expandConfigView(!this.props.app.configuredExpanded))
  private toggleExpandTemplates = () => this.props.dispatch(expandTemplatesView(!this.props.app.templatesExpanded))
  private toggleExpandWebhook = () => this.props.dispatch(expandWebhookView(!this.props.app.webhookExpanded))
  private saveKey = (values: any, actions: FormikActions<any>) => {
    const accessToken = this.props.authentication.session.id
    const tenantId = this.props.tenant.id
    this.props.dispatch(updateKey(
      accessToken,
      tenantId,
      values.accountId,
      values.token,
    ))
  }
  private generateWebhook = () => {
    const accessToken = this.props.authentication.session.id
    const tenantId = this.props.tenant.id
    this.props.dispatch(generateWebhook(
      accessToken,
      tenantId,
    ))
  }
  private saveTemplates = (values: any, actions: FormikActions<any>) => {
    const accessToken = this.props.authentication.session.id
    const tenantId = this.props.tenant.id
    this.props.dispatch(saveTemplates(
      accessToken,
      tenantId,
      values.templates,
    ))
  }

  private toggleShowToken = () => {
    this.props.dispatch(toggleToken(!this.props.auth.showToken))
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default withStyles(styles)(withRouter(connect(
  mapStateToProps,
)(RoostifyContent)));



// WEBPACK FOOTER //
// ./src/sub-projects/roostify/containers/content.tsx